const regexCpfCnpj = /(^\d{3}\.\d{3}\.\d{3}-\d{2}$)|(^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$)/
const regexCpf = /^[0-9]{3}.[0-9]{3}.[0-9]{3}-[0-9]{2}$/
const regexPhone = /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))$/
const regexName = /^[A-Za-záàâãéèêíïóôõöúçñÁÀÂÃÉÈÍÏÓÔÕÖÚÇÑ ]+$/
const regexEmail = /^([a-zA-Z0-9._%-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,})$/

export const isEmail = (data) => {
  return regexEmail.test(data);
}

export const isName = (data) => {
  return regexName.test(data);
}

export const isPhone = (data) => {
  return regexPhone.test(data);
}

export const isCpfOrCnpj = (data) => {
  return regexCpfCnpj.test(data);
}

export const isCpf = (data) => {
  return regexCpf.test(data);
}



// WEBPACK FOOTER //
// ./src/services/utils/regexForValidations.js